/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const Complexe = require('../types/Complexe')
const Opef3v = require('../types/Opef3v')
const kernel = require('../kernel/kernel')
const CCb = require('./CCb')
const CCbGlob = require('../kernel/CCbGlob')
module.exports = CFonction3Var

/**
 * @constructor
 * @extends CCb
 * Classe représentant dans un arbre binaire de calcul un appel de fonction
 * prédéfinie à trois variables : la seule fonction est si
 * dont la syntaxe est si(test, valeursivari, valeursifaux)
 * Si test vaux 1, renvoie valeursivari et sinon valeur si faux.
 * @constructor
 * @extends CCb
 * @param {CListeObjets} listeProprietaire : La liste proprétaire
 * @param {Integer} Opef : Voir Opef3v. Caractérise la fonction.
 * @param {CCb} operande1 : Le premier opérande test (vrai si 1, faux si 0)
 * @param {CCb} operande2 : Le deuxième opérande valeursivrai
 * @param {CCb} operande3 : Le troisième opérande valeursifaux
 * @returns {CFonction3Var}
 */
function CFonction3Var (listeProprietaire, Opef, operande1, operande2, operande3) {
  CCb.call(this, listeProprietaire);
  if (arguments.length !== 1) {
    this.Opef = Opef;
    this.operande1 = operande1;
    this.operande2 = operande2;
    this.operande3 = operande3;
  }
  this.z1loc = new Complexe();
  this.z2loc = new Complexe();
  this.z3loc = new Complexe();
}
CFonction3Var.prototype = new CCb();
CFonction3Var.prototype.constructor = CFonction3Var;
CFonction3Var.prototype.superClass = "CCb";
CFonction3Var.prototype.className = "CFonction3Var";


CFonction3Var.prototype.nombreVariables = function() {
  return 3;
};

CFonction3Var.prototype.nature = function() {
  return CCbGlob.natFonction3Var;
};

CFonction3Var.prototype.getClone = function(listeSource, listeCible) {
  var cloneOperande1 = this.operande1.getClone(listeSource, listeCible);
  var cloneOperande2 = this.operande2.getClone(listeSource, listeCible);
  var cloneOperande3 = this.operande3.getClone(listeSource, listeCible);
  return new CFonction3Var(listeCible, this.Opef, cloneOperande1, cloneOperande2,
      cloneOperande3);
};

CFonction3Var.prototype.initialisePourDependance = function() {
  CCb.prototype.initialisePourDependance.call(this);
  this.operande1.initialisePourDependance();
  this.operande2.initialisePourDependance();
  this.operande3.initialisePourDependance();
};

CFonction3Var.prototype.dependDe = function(p) {
  return this.memoriseDependance(CCb.prototype.dependDe.call(this,p) || this.operande1.dependDe(p) ||
    this.operande2.dependDe(p) || this.operande3.dependDe(p));
};

CFonction3Var.prototype.dependDePourBoucle = function(p) {
  return this.operande1.dependDePourBoucle(p) || this.operande2.dependDePourBoucle(p)
    || this.operande3.dependDePourBoucle(p);
};
/**
 * Fonction renvoyant 1 si le calcul existe et 0 sinon.
 * Cette fonction et particulière pour le si :
 * Si operande1 existe et s'il renvoie la valeur 1 existe renverra true
 * si et seulement operande2 existe et s'il renvoie une autre valeur existe
 * renverra true ssi operande3 existe
 * @param {Boolean} infoRandom : true si les calculs aléatoires pas rand doivent réinitialisés.
 * @returns {Boolean}
 */
CFonction3Var.prototype.existe = function(infoRandom) {
  if (!this.operande1.existe(infoRandom)) return false;
  // Modifié version 4.8
  if (this.operande1.className === "CResultatValeur") {
    return  (this.operande1.resultat(infoRandom) === 1) ? this.operande2.existe(infoRandom) : this.operande3.existe(infoRandom);
  }
  else {
    if (this.operande1.className === "CResultatValeur") {
      var z = new Complexe();
      this.operande1.resultatComplexe(infoRandom, z);
      if ((z.y === 0) && (z.x === 1)) return this.operande2.existe(infoRandom); else return this.operande3.existe(infoRandom);
    }
    else {
      try{
        var x1 = this.operande1.resultat(infoRandom);
  			if (x1 === 1) return this.operande2.existe(infoRandom);
  			else return this.operande3.existe(infoRandom);
      } catch (e) {
        return false;
      }
    }
  }
};
// Pour une fonction réelle ou complexe de une ou plusieurs variables, quand on teste son existence, on appelle
// existe. Or CFonction3Var.existe, dans le cas d'une fonction si provoque un appel de calcul pour un calcul normal
// qu'il faut éviter quand une fonction utilise un si et qu'on teste son existence

CFonction3Var.prototype.existePourFonc = function() {
	return this.operande1.existePourFonc() && this.operande2.existePourFonc() && this.operande3.existePourFonc();
};

CFonction3Var.prototype.resultat = function(infoRandom) {
  var x1 = this.operande1.resultat(infoRandom);
  if (x1 === 1) return this.operande2.resultat(infoRandom);
  else return this.operande3.resultat(infoRandom);
};

CFonction3Var.prototype.resultatFonction = function(infoRandom, valeurParametre) {
  var x1 = this.operande1.resultatFonction(infoRandom, valeurParametre);
  if (x1 === 1) return this.operande2.resultatFonction(infoRandom, valeurParametre);
  else return this.operande3.resultatFonction(infoRandom, valeurParametre);
};

CFonction3Var.prototype.resultatFonction = function(infoRandom, valeurParametre) {
  var x1 = this.operande1.resultatFonction(infoRandom, valeurParametre);
  if (x1 === 1) return this.operande2.resultatFonction(infoRandom, valeurParametre);
  else return this.operande3.resultatFonction(infoRandom, valeurParametre);
};
CFonction3Var.prototype.resultatComplexe = function(infoRandom, zRes) {
  this.operande1.resultatComplexe(infoRandom, this.z1loc);
  if (this.z1loc.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
  if (this.z1loc.x === 1) {
    this.operande2.resultatComplexe(infoRandom, this.z2loc);
    zRes.x = this.z2loc.x;
    zRes.y = this.z2loc.y;
  }
  else {
    this.operande3.resultatComplexe(infoRandom, this.z3loc);
    zRes.x = this.z3loc.x;
    zRes.y = this.z3loc.y;
  }
};

CFonction3Var.prototype.resultatFonctionComplexe = function(infoRandom, valeurParametre, zRes){
  this.operande1.resultatFonctionComplexe(infoRandom, valeurParametre, this.z1loc);
  if (this.z1loc.y !== 0) throw new Error(kernel.erreurCalculExceptionkernel._digit64_standard);
  if (this.z1loc.x === 1) {
    this.operande2.resultatFonctionComplexe(infoRandom, valeurParametre, this.z2loc);
    zRes.x = this.z2loc.x;
    zRes.y = this.z2loc.y;
  }
  else {
    this.operande3.resultatFonctionComplexe(infoRandom, valeurParametre, this.z3loc);
    zRes.x = this.z3loc.x;
    zRes.y = this.z3loc.y;
  }
};

CFonction3Var.prototype.dependDeVariable = function(ind) {
  return this.operande1.dependDeVariable(ind) || this.operande2.dependDeVariable(ind) || this.operande3.dependDeVariable(ind);
};

CFonction3Var.prototype.getCopie = function() {
  return new CFonction3Var(this.listeProprietaire, this.Opef, this.operande1.getCopie(),
  this.operande2.getCopie(), this.operande3.getCopie());
};

CFonction3Var.prototype.chaineCalcul = function(varFor) {
  var cha1, cha2, cha3;
  cha1 = this.operande1.chaineCalculSansPar(varFor);
  cha2 = this.operande2.chaineCalculSansPar(varFor);
  cha3 = this.operande3.chaineCalculSansPar(varFor);
  var ch = "(" + cha1 + "," + cha2 + "," + cha3 + ")";

  switch (this.Opef)
  {
    case Opef3v.si:
    case Opef3v.siC:
      return kernel.getString("si") + ch;
    default : return "";
  }
};

CFonction3Var.prototype.chaineLatex = function(varFor) {
  var parouvLatex = "\\left(";
  var parferLatex = "\\right)";
  var cha1, cha2, cha3;
  cha1 = this.operande1.chaineLatexSansPar(varFor);
  cha2 = this.operande2.chaineLatexSansPar(varFor);
  cha3 = this.operande3.chaineLatexSansPar(varFor);
  var ch = parouvLatex + cha1 + "," + cha2 + "," + cha3 + parferLatex;

  switch (this.Opef)
  {
    case Opef3v.si:
    case Opef3v.siC:
      return kernel.getString("si") + ch;
    default : return "";
  }
};

CFonction3Var.prototype.read = function(inps, list) {
  CCb.prototype.read.call(this,inps, list);
  this.Opef = inps.readByte();
  this.operande1 = inps.readObject(list);
  this.operande2 = inps.readObject(list);
  this.operande3 = inps.readObject(list);
};

CFonction3Var.prototype.write = function(oups, list) {
  CCb.prototype.write.call(this,oups, list);
  oups.writeByte(this.Opef);
  oups.writeObject(this.operande1);
  oups.writeObject(this.operande2);
  oups.writeObject(this.operande3);
};

CFonction3Var.prototype.estConstant = function() {
  return (this.operande1.estConstant() && this.operande2.estConstant() && this.operande3.estConstant());
};

CFonction3Var.prototype.deriveePossible = function(indiceVariable) {
  return this.operande1.deriveePossible(indiceVariable)
  && this.operande2.deriveePossible(indiceVariable) && this.operande3.deriveePossible(indiceVariable);
};

CFonction3Var.prototype.calculAvecValeursRemplacees = function() {
  return new CFonction3Var(this.listeProprietaire, this.Opef, this.operande1.calculAvecValeursRemplacees(),
      this.operande2.calculAvecValeursRemplacees(), this.operande3.calculAvecValeursRemplacees());
};




// WEBPACK FOOTER //
// ./src/objets/CFonction3Var.js